// extracted by mini-css-extract-plugin
module.exports = {"header":"layout-module--header--7X126","menu":"layout-module--menu--sgu2b","menuIcon":"layout-module--menuIcon--2ALVW"};